import { t } from '../../../content';

import greenLogoNoText from "../../../assets/images/logos/apex_analytics_green_logo.svg";
import groupOfPeople from "../../../assets/images/icons/groupOfPeople.svg";
import suitcase from "../../../assets/images/icons/suitcase.svg";
import question from "../../../assets/images/icons/question.svg";
import cog from "../../../assets/images/icons/cog.svg";
import ShareIconMui from "@mui/icons-material/Share";

const buildPrimaryMenuItems = () => [
  {
    enabled: true,
    canBeLocked: true,
    id: "dashboard",
    title: t("nav.items.dashboard"),
    icon: <img className="navIcon" src={groupOfPeople} alt="dashboard" />,
    submenu: [
      {
        id: "dashboard",
        title: t("nav.items.dashboard"),
        path: "/",
      },
    ],
  },
  {
    enabled: true,
    canBeLocked: false,
    id: "assessments",
    title: t("nav.items.assessments"),
    icon: <img className="navIcon" src={suitcase} alt="assessments" />,
    submenu: [
      {
        id: "assessments",
        title: t("nav.items.assessments"),
        path: "/assessment",
      },
    ],
  },
  {
    enabled: true,
    canBeLocked: false,
    id: "dataShareInvites",
    title: t("nav.items.dataShareInvites"),
    path: "/data-share-invites",
    icon: <ShareIconMui className="navIcon" />,
    submenu: [
      {
        id: "dataShareInvites",
        title: t("nav.items.dataShareInvites"),
        path: "/data-share-invites",
      },
    ],
  },
];

export const PrimaryMenu = () => buildPrimaryMenuItems();

export const SecondaryMenu = () => [
  {
    enabled: true,
    id: "helpCenter",
    title: t("nav.items.helpCenter"),
    path: "/faq-page",
    icon: <img className="navIcon" src={question} alt="FAQ" />,
  },
  {
    enabled: true,
    id: "settings",
    title: t("nav.items.settings"),
    path: "/settings",
    icon: <img className="navIcon" src={cog} alt="settings" />,
  },
];

export const MobilePrimaryMenu = () => [
  {
    id: "dashboard",
    title: t("nav.items.dashboard"),
    path: "/",
    icon: <img className="navIcon" src={groupOfPeople} alt="dashboard" />,
    canBeLocked: true,
  },
  {
    id: "logo",
    title: "Logo",
    icon: (
      <img
        className="navIcon"
        style={{ height: "100%", width: "55px" }}
        src={greenLogoNoText}
        alt="Apex Analytics"
      />
    ),
  },
  {
    id: "assessments",
    title: t("nav.items.assessments"),
    path: "/assessment",
    icon: <img className="navIcon" src={suitcase} alt="assessments" />,
    canBeLocked: false,
  },
  {
    id: "dataShareInvites",
    title: t("nav.items.dataShareInvites"),
    path: "/data-share-invites",
    icon: <ShareIconMui className="navIcon" />,
    canBeLocked: false,
  },
];

export const MobileSecondaryMenu = () => [
  {
    id: "helpCenter",
    title: t("nav.items.helpCenter"),
    path: "/faq-page",
    icon: <img className="navIcon" src={question} alt="FAQ" />,
  },
  {
    id: "settings",
    title: t("nav.items.settings"),
    path: "/settings",
    icon: <img className="navIcon" src={cog} alt="settings" />,
  },
];
